export const LOAD_ACTIVITIES = 'LOAD_ACTIVITIES'
export const ACTIVITIES_WAS_LOADED = 'ACTIVITIES_WAS_LOADED'

export const loadActivities = (requestId) =>
  ({ type: LOAD_ACTIVITIES, requestId })
export const activitiesWasLoaded = (data) =>
  ({ type: ACTIVITIES_WAS_LOADED, data })
